// @ts-nocheck

// VIEW EDITOR TEXT CONSTANTS by tab

export default {
  SCREEN: {
    VIEW_INPUT_TITLE: 'View Name',
    PREVIEW_INPUT_TITLE: 'Preview Device',
    PREVIEW_INPUT_TOOLTIP:
      'Note that Journeys rendered on actual mobile devices may differ slightly from Journeys previews due to differences between web browsers and operating system versions. We recommend testing Journeys on devices before deploying. Dark grey areas on device previews are an approximation of the space occupied by web browser search and navigation bars.',
  },
  // 1. View Editor Tab
  VIEW_EDITOR: {
    TAB_TITLE: 'View Editor',
    DISMISSAL: {
      CONFIGURATION: {
        HEADING: 'Dismiss Journey configuration',
        SUBHEADING: 'Select how users can dismiss the Journey.',
        BUTTON_CHECKBOX: 'Button',
        TEXT_CHECKBOX: 'Dismiss Journey text',
      },
      AMP_NOTE: {
        TITLE: 'Note',
        BODY: 'Additional Dismissal Settings are not available for AMP Journeys.',
      },
      DISMISSAL_SETTINGS_LINK: 'Set up Dismissal Settings',
    },
  },
  // 2. CSS Editor Tab
  CSS_EDITOR: {
    TAB_TITLE: 'CSS Editor',
  },
  // 3. HTML Editor Tab
  HTML_EDITOR: {
    TAB_TITLE: 'HTML Editor',
  },
  // 4. Page Placement Tab
  PAGE_PLACEMENT: {
    TAB_TITLE: 'Page Placement',
  },
  CONFIG: {
    TAB_TITLE: 'Configuration',
  },
  // 5. Dismissal Settings Tab
  DISMISSAL_SETTINGS: {
    TAB_TITLE: 'Dismissal Settings',
    BEHAVIOR: {
      HEADING: 'Dismissal behavior',
      SUBHEADING: 'Choose what should happen when the Journey is dismissed.',
      RADIO_ITEMS: {
        CLOSE: 'Close Journey',
        REDIRECT: 'Redirect to a web page',
      },
    },
    TIME_PERIOD: {
      HEADING: 'Dismissal period',
      SUBHEADING:
        'Decide how long the Journey should be dismissed for, and whether that dismissal period should apply to all Journeys or just this one.',
      CUSTOM_UNIT_SINGULAR: 'hour',
      CUSTOM_UNIT_PLURAL: 'hours',
      RADIO_ITEMS: {
        GLOBAL: 'Dismiss all Journeys',
        LOCAL: 'Dismiss this Journey',
      },
    },
  },
  // 6. CSS and HTML single tab
  CSS_HTML_EDITOR: {
    TAB_TITLE: 'CSS/HTML Editor',
  },
};
